import React from 'react';
import SignUp from '../../@jumbo/components/Common/authComponents/SignUp';

const RegisterTravel = () => <SignUp variant="travel" wrapperVariant="bgColor" />;

export default RegisterTravel;
